import { checkRules } from '../../../../../../utils/formRules';

export const VALIDABLE_FALSE = {
  docket_number: false,
  reference_number: false,
  compressive_strength: false,
};

export const VALIDABLE_TRUE = {
  docket_number: true,
  reference_number: true,
  compressive_strength: true,
};

export const FORMSATTR = {
  phone_number: {
    rules: { min: 3, max: 9, type: 'integer' },
    value: '',
    status: [[{ id: 'minLength' }, { min: '3' }]],
  },
  email: {
    rules: { min: 3, max: 40, type: 'email' },
    value: '',
    status: [[{ id: 'minLength' }, { min: '3' }]],
  },
  supplier_id: {
    rules: { min: 3, max: 30, type: 'string' },
    value: '',
    status: [[{ id: 'minLength' }, { min: '3' }]],
  },
  templateName: {
    rules: { min: 3, max: 30, type: 'string' },
    value: '',
    status: [[{ id: 'minLength' }, { min: '3' }]],
  },

  docket_number: {
    rules: { required: true, maxLength: 10, type: 'integer' },
    value: '',
    status: [[{ id: 'required' }]],
  },
  reference_number: {
    rules: { required: true, maxLength: 30, type: 'fullString' },
    value: '',
    status: [[{ id: 'required' }]],
  },
  project: {
    rules: { type: 'string' },
    value: '',
    status: [],
  },
  compressive_strength: {
    rules: { type: 'compressive_strength' },
    value: [
      {
        day: '',
        value1: '',
        value2: '',
        value3: '',
      },
    ],
    status: {
      day0: [[{ id: 'required' }]],
      row0: [[{ id: 'row' }]],
    },
    customValidation: ({ compressive_strength }, newValue) => {
      const floatRule = { minValue: 0, type: 'float' };
      const intRule = {
        required: true,
        minValue: 1,
        maxValue: 99,
        type: 'integer',
      };
      if (Array.isArray(newValue) && newValue.length > 0) {
        compressive_strength.value = newValue;
        for (let i = 0; i < newValue.length; i++) {
          compressive_strength.status[`day${i}`] = checkRules(
            newValue[i].day,
            intRule,
          );
          compressive_strength.status[`value${i}1`] = checkRules(
            newValue[i].value1,
            floatRule,
          );
          compressive_strength.status[`value${i}2`] = checkRules(
            newValue[i].value2,
            floatRule,
          );
          compressive_strength.status[`value${i}3`] = checkRules(
            newValue[i].value3,
            floatRule,
          );
        }
      } else if (typeof newValue === 'object') {
        if (newValue.action === 'updateValue') {
          compressive_strength.value[newValue.positionI][
            `value${newValue.positionJ}`
          ] = newValue.value;
          compressive_strength.status[
            `value${newValue.positionI}${newValue.positionJ}`
          ] = checkRules(
            compressive_strength.value[newValue.positionI][
              `value${newValue.positionJ}`
            ],
            floatRule,
          );
        }
        if (newValue.action === 'updateDay') {
          compressive_strength.value[newValue.positionI][`day`] = newValue.day;
          compressive_strength.status[`day${newValue.positionI}`] = checkRules(
            compressive_strength.value[newValue.positionI][`day`],
            intRule,
          );
        }
        if (newValue.action === 'addFile') {
          compressive_strength.value.push({
            day: '',
            value1: '',
            value2: '',
            value3: '',
          });
          const newSize = compressive_strength.value.length - 1;
          compressive_strength.status[`day${newSize}`] = checkRules(
            compressive_strength.value[newSize][`day`],
            intRule,
          );
          compressive_strength.status[`row${newSize}`] = [];
          compressive_strength.status[`value${newSize}1`] = [];
          compressive_strength.status[`value${newSize}2`] = [];
          compressive_strength.status[`value${newSize}3`] = [];
        }

        if (newValue.action === 'deleteFile') {
          if (compressive_strength.value.length > 1) {
            compressive_strength.value.splice(newValue.deleteRawI, 1);
            delete compressive_strength.status[`day${newValue.deleteRawI}`];
            delete compressive_strength.status[`value${newValue.deleteRawI}1`];
            delete compressive_strength.status[`value${newValue.deleteRawI}2`];
            delete compressive_strength.status[`value${newValue.deleteRawI}3`];
            delete compressive_strength.status[`row${newValue.deleteRawI}`];
          }
        }
      }
      for (let i = 0; i < compressive_strength.value.length; i++) {
        const index = compressive_strength.value.findIndex((element) => {
          return (
            String(element.day) === String(compressive_strength.value[i].day)
          );
        });
        if (index > -1 && index !== i) {
          if (
            compressive_strength.status[`day${i}`] &&
            compressive_strength.status[`day${i}`].findIndex(
              (error) => error[0].id === 'dayduplicated',
            ) === -1
          )
            compressive_strength.status[`day${i}`].push([
              { id: 'dayduplicated' },
            ]);
          else
            compressive_strength.status[`day${i}`] = [
              [{ id: 'dayduplicated' }],
            ];
          if (
            compressive_strength.status[`day${index}`] &&
            compressive_strength.status[`day${index}`].findIndex(
              (error) => error[0].id === 'dayduplicated',
            ) === -1
          )
            compressive_strength.status[`day${index}`].push([
              { id: 'dayduplicated' },
            ]);
          else
            compressive_strength.status[`day${index}`] = [
              [{ id: 'dayduplicated' }],
            ];
        } else {
          compressive_strength.status[`day${i}`] =
            compressive_strength.status[`day${i}`]?.filter(
              (element) => element[0]?.id !== 'dayduplicated',
            ) || [];
        }
        if (
          !compressive_strength.value[i].value1 &&
          !compressive_strength.value[i].value2 &&
          !compressive_strength.value[i].value3
        ) {
          if (
            compressive_strength.status[`row${i}`] &&
            compressive_strength.status[`row${i}`].findIndex(
              (error) => error[0].id === 'row',
            ) === -1
          )
            compressive_strength.status[`row${i}`].push([{ id: 'row' }]);
          else compressive_strength.status[`row${i}`] = [[{ id: 'row' }]];
        } else {
          compressive_strength.status[`row${i}`] =
            compressive_strength.status[`row${i}`]?.filter(
              (element) => element[0]?.id !== 'row',
            ) || [];
        }
      }
      return { compressive_strength };
    },
  },
};
